import * as React from "react";

import { useAnalytics } from "@/providers";
import { Button, type ButtonProps } from "@/shared/foundation/primitives";
import {
  EventName,
  ComponentPropsWithEvent,
} from "@/shared/services/analytics";

type RobotoButtonPropsWithEvent<T extends EventName> = ComponentPropsWithEvent<
  T,
  ButtonProps
>;

// This function type overload provides better intellisense by telling the author
// what field is missing from the event properties. Without this, it'll just say
// "Your value for eventProperties does not match the expected type."
export function RobotoButton<T extends EventName>(
  props: RobotoButtonPropsWithEvent<T>,
): JSX.Element;

/**
 * Button wrapped with Analytics
 */
export function RobotoButton(
  props: Partial<RobotoButtonPropsWithEvent<EventName>>,
): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { onClick, eventName, eventProperties, ...buttonProps } = props;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (eventName) {
      trackEvent(eventName, eventProperties);
    }
    onClick?.(event);
  };

  return (
    <Button onClick={handleClick} {...buttonProps}>
      {props.children}
    </Button>
  );
}
